export enum Status {
  APPROVED = 'approved',
  FAILED = 'failed',
  IN_PROGRESS = 'in_progress',
  NOT_APPLICABLE = 'not_applicable',
  PENDING = 'pending',
  REJECTED = 'rejected',
  SUBMITTABLE = 'submittable',
  UNSUBMITTABLE = 'unsubmittable',
}

export enum Actions {
  APPROVE = 'approve',
  REJECT = 'reject',
}

export enum Settings {
  AUTOMATIC = 'automatic',
  MANUAL = 'manual',
}

export enum Prerequisite {
  PUBLISHED = 'published',
}

export enum ResubmissionSettings {
  MAINTAIN_STATE = 'maintain_state',
  RESUBMIT = 'resubmit',
}
/** The outcome of approval for the asset */
export enum Outcome {
  CHANGE_AUDIENCE = 'change_audience',
  UPDATE_PUBLISHED_ASSET = 'update_published_asset',
}

/** The status of applying the 'submission_outcome' to the asset */
export enum SubmissionOutcomeStatus {
  FAILURE = 'failure',
  IN_PROGRESS = 'in_progress',
  NOT_APPLICABLE = 'not_applicable',
  SUCCESS = 'success',
  UNCLAIMED = 'unclaimed',
}

/**
 * The approvals state of the asset.
 *
 * NOTE: The values documented in the Discovery API schema are:
 * `not_ready`, `pending`, `approved`, `rejected`.
 * The additional values (`not_applicable`, `submittable`, `unsubmittable`) were already present here
 * before the schema comparison, so they are retained. `not_ready` was added to align with the schema.
 */
export enum ApprovalState {
  NOT_APPLICABLE = 'not_applicable',
  NOT_READY = 'not_ready',
  SUBMITTABLE = 'submittable',
  UNSUBMITTABLE = 'unsubmittable',
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum SubmissionObject {
  PUBLIC_AUDIENCE_REQUEST = 'public_audience_request',
  WORKING_COPY = 'working_copy',
  REVISION = 'revision',
  DRAFT_STORY = 'draft_story',
}

export enum WorkflowTaskScope {
  ALL = 'all',
  COMMUNITY = 'community',
  OFFICIAL = 'official',
}

/** The audience the asset would like if approved */
export enum WorkflowTargetAudience {
  PUBLIC = 'public',
  INTERNAL = 'internal',
}

export const APPROVALS = {
  STATUS: Status,
  ACTIONS: Actions,
  SETTINGS: Settings,
  PREREQUISITE: Prerequisite,
  RESUBMISSION_SETTINGS: ResubmissionSettings,
  OUTCOME: Outcome,
  SUBMISSION_OUTCOME_STATUS: SubmissionOutcomeStatus,
  APPROVAL_STATE: ApprovalState,
  WORKFLOW_TARGET_AUDIENCE: WorkflowTargetAudience,
};
